const AVATAR_MIME_TYPES = ["image/jpeg", "image/png", "image/webp"];
const AVATAR_MAX_SIZE_MB = 5;
const AVATAR_MAX_SIZE_BYTES = AVATAR_MAX_SIZE_MB * 1024 * 1024;

export const AVATAR_ACCEPT = AVATAR_MIME_TYPES.join(",");

// Обрезку пропорций и проверку содержимого делает сервер — здесь только то,
// что можно отсечь до отправки.
export const validateAvatarFile = (file: File): string | null => {
  if (!AVATAR_MIME_TYPES.includes(file.type)) {
    return "Only JPEG, PNG and WebP images are supported.";
  }
  if (file.size > AVATAR_MAX_SIZE_BYTES) {
    return `The image must be at most ${AVATAR_MAX_SIZE_MB} MB.`;
  }
  return null;
};
